import { put, select, call, takeLatest } from 'redux-saga/effects';

import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { formatError } from '../../../libs';
import categoryAPI from '../../api/category';
import { Types, Creators as CategoryCreators } from '../../reducers/category';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* setSearchQuery({ field, value }) {
  try {
    const {
      category: { filters, searchQuery, products },
      search,
      app,
    } = yield select(getState);

    const siteId = app.getIn(['config', 'siteId']);
    const token = yield select(getToken);

    let sortBy = searchQuery.getIn(['sortBy']) || filters.getIn(['sortBy']);
    let offset = 0;
    let filter = searchQuery.getIn(['filter']);
    let exists = false;

    if (field && value) {
      if (field !== 'sortBy' && field !== 'offset') {
        if (searchQuery.getIn(['filter', field])) {
          exists = searchQuery.getIn(['filter', field]).find((item) => item.value === value);
        }

        if (!exists) {
          filter = searchQuery.getIn(['filter']).merge({
            ...searchQuery.getIn(['filter']),
            [field]: [...(searchQuery.getIn(['filter', field]) || []), { id: field, value, fixed: false }],
          });
        } else {
          filter = searchQuery.getIn(['filter']).merge({
            ...searchQuery.getIn(['filter']),
            [field]: searchQuery.getIn(['filter', field]).filter((item) => item.value !== value),
          });
        }
      }

      if (field === 'sortBy') {
        sortBy = value;
      }

      if (field === 'offset') {
        offset = searchQuery.getIn(['offset']);
      }
    }

    let queryString = [];

    forEach(filter, (item) => {
      queryString = [...queryString, ...map(item, (subItem) => JSON.stringify(subItem))];
    });

    const queryParams = {
      ...searchQuery,
      sortBy,
      offset,
      filter: `[${queryString.join(',')}]`,
    };

    if (search.getIn(['param', 'field']) === 'busca') {
      queryParams.content = search.getIn(['param', 'value']);
    }

    if (isEmpty(queryParams.content)) {
      delete queryParams.content;
    }

    const { _result = {}, products: productsCategory = [] } = yield call(
      categoryAPI.getProducts,
      queryParams,
      siteId,
      token
    );
    const aggregateProducts = field === 'offset' ? [...products, ...productsCategory] : productsCategory;

    yield put(
      CategoryCreators.setSearchQuerySuccess({
        searchQuery: { ...searchQuery, sortBy, offset, filter },
        products: aggregateProducts,
        totalProducts: aggregateProducts.length > 0 ? _result.total : 0,
        scrollTo: field !== 'offset',
      })
    );
    yield put(CategoryCreators.getFilteredItemsRequest());
  } catch (error) {
    yield put(CategoryCreators.setSearchQueryError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SET_SEARCH_QUERY_REQUEST, setSearchQuery);
}
